import { atom } from 'jotai';

export type CategoryToggleValue = 'interior' | 'building';

/**
 * Atom to store the current category toggle state (Interior/Building)
 * Shared between CategoryPageProducts and EditorsChoice components
 * Default value: 'interior'
 */
export const categoryToggleAtom = atom<CategoryToggleValue>('interior');

/** URL prefix for building-hardware subcategory pages */
export const BUILDING_HARDWARE_SUBCATEGORY_PREFIX =
    '/products/building-hardware/';
